import { Segmented, Typography } from 'antd';
import type { SimulationServiceVersion } from '~/store/simulation/types';

export interface VersionPickerProps {
  value: SimulationServiceVersion;
  onChange: (version: SimulationServiceVersion) => void;
  disabled?: boolean;
}

const OPTIONS: { label: string; value: SimulationServiceVersion }[] = [
  { label: 'V2 (recommended)', value: 'v2' },
  { label: 'V1 (legacy)', value: 'v1' },
];

// Describe the engines by capability (mirrors the create-simulation wording).
const DESCRIPTIONS: Record<SimulationServiceVersion, string> = {
  v2: 'The new simulation runner. Simulates a previously uploaded shipment file over any date window (no 31-day limit) and performs better on both sparse and dense datasets.',
  v1: 'The legacy engine. Pulls a recent range of real shipments (up to 31 days) or runs an uploaded file.',
};

export const VersionPicker: React.FC<VersionPickerProps> = ({ value, onChange, disabled }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
    <Segmented
      options={OPTIONS}
      value={value}
      disabled={disabled}
      onChange={(next) => onChange(next as SimulationServiceVersion)}
    />
    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
      {DESCRIPTIONS[value]} This choice is locked once the simulation is created.
    </Typography.Text>
  </div>
);
